import Vue from 'vue'
import { Form, Button, Input, Modal, Select, Icon, Upload, message } from 'ant-design-vue'
import Storage from 'vue-ls'
import UserIcon from '@/components/icon'

import './css/index.less'

Vue.use(Form)
Vue.use(Button)
Vue.use(Input)
Vue.use(Icon)
Vue.use(Upload)
Vue.use(Modal)
Vue.use(Select)
Vue.use(UserIcon)
Vue.prototype.$error = Modal.error
Vue.prototype.$success = Modal.success
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$message = message
Vue.use(Storage)
